$(function () {
    let datatxt
    new WOW().init();
    var TrandingSlider = new Swiper(".tranding-slider", {
        slidesPerView: 3,
        loop: true,
        pagination: {
            el: ".swiper-pagination8",
            clickable: true,
        },
        on:{
            slideChange: function(){
                setTimeout(() => {
                    enquire.register("screen and (max-width: 768px)", {
                        match : function() {
                            switch($(".c2_boxs.swiper-slide-next").attr("data-swiper-slide-index")){
                                case "0":
                                    MB('series');
                                    break;
                                case "1":
                                    MB('sale');
                                    break;
                                case "2":
                                    MB('materials');
                                    break;
                                case "3":
                                    MB('ecr');
                                    break;
                                case "4":
                                    MB('supplier');
                                    break;
                            }
                        },
                    
                    });
                    
                },0)
            },
            click: function(){
                setTimeout(() => {
                    
                    if(this.clickedIndex === 10 || this.clickedIndex === 0){
                        this.slideTo(4);
                    }else{
                        this.slideTo(this.clickedIndex-1);
                    }
                },0);
            }
        },
    });

    $(document).on("click", ".c5_more", function () {
        $(this).find("img").toggleClass("c5_tr");
        if ($(this).find("h3").text() === "更多資訊") {
            $(this).find("h3").text("較少資訊");
            $(this).siblings(".c5_txt").show();
        } else {
            $(this).find("h3").text("更多資訊");
            $(this).siblings(".c5_txt").hide();
        }
    });

    $(document).on("click", ".c2_boxs1", function () {
        console.log("123")
        enquire.register("screen and (min-width: 769px)", {
            match : function() {
                PC('series');
            },
        });
        enquire.register("screen and (max-width: 768px)", {
            match : function() {
                MB('series');
            },
        });
    });
    $(document).on("click", ".c2_boxs2", function () {
        enquire.register("screen and (min-width: 769px)", {
            match : function() {
                PC('sale');
            },
        });
        enquire.register("screen and (max-width: 768px)", {
            match : function() {
                MB('sale');
            },
        });
    });
    $(document).on("click", ".c2_boxs3", function () {
        enquire.register("screen and (min-width: 769px)", {
            match : function() {
                PC('materials');
            },
        });
        enquire.register("screen and (max-width: 768px)", {
            match : function() {
                MB('materials');
            },
        });
    });
    $(document).on("click", ".c2_boxs4", function () {
        enquire.register("screen and (min-width: 769px)", {
            match : function() {
                PC('ecr');
            },
        });
        enquire.register("screen and (max-width: 768px)", {
            match : function() {
                MB('ecr');
            },
        });
    });
    $(document).on("click", ".c2_boxs5", function () {
        enquire.register("screen and (min-width: 769px)", {
            match : function() {
                PC('supplier');
            },
        });
        enquire.register("screen and (max-width: 768px)", {
            match : function() {
                MB('supplier');
            },
        });
    });
    PC('series');

    function PC (txt){
        enquire.register("screen and (min-width: 769px)", {
            match : function() {
                $.ajax({
                    url: 'db.json', 
                    type: 'GET',
                    dataType: 'json',
                    success: function(data) {
                        $(".c3_preparespc").empty()
                        data[txt][0].box.forEach((item, index) => {
                            $(".c3_preparespc").append(`
                                <div style="${item.style}" class="c3_prepare" data-fancybox="group" href="${item.fancyboximg}">
                                    <div class="c3_pretxt">
                                        <img src="${item.picture}" alt="">
                                        <div class="c3_pretxtp">
                                            <p>${item.boxtxt}</p>
                                        </div>
                                    </div>
                                    <h2>${item.company}</h2>
                                </div>
                            `)
                        });
                        $(".c3 h1").text(`${data[txt][0].title}`)
                        $(".c3 .c3_pc").html(`${data[txt][0].narrate}`)
                    },
                    error: function(xhr, status, error) {
                        console.log("Error: " + error);
                    }
                });
               
            },
         
        });
    }
    function MB (txt){
     
        if(datatxt !== txt){
            console.log(txt)
            console.log(datatxt)
            datatxt = txt
            enquire.register("screen and (max-width: 768px)", {
                match : function() {
                    $.ajax({
                        url: 'db.json', 
                        type: 'GET',
                        dataType: 'json',
                        success: function(data) {
                            $(".c3_preparesmb").empty();
                            console.log(data)
                            data[txt][0].box.forEach((item, index) => {
                                $(".c3_preparesmb").append(`
                                    <div style="${item.style}" class="c3_prepare" data-fancybox="group" href="${item.fancyboximgmb}">
                                        <img src="${item.picture}" alt="">
                                        <h2>${item.company}</h2>
                                    </div>
                                `)
                            });
                            $(".c3 h1").text(`${data[txt][0].title}`)
                            $(".c3 .c3_pMB").html(`${data[txt][0].narratemb}`)
                        },
                        error: function(xhr, status, error) {
                            console.log("Error: " + error);
                        }
                    });
                    
                },
            
            });
        }
    }

    
    // $(".page-submenubox .tel").replaceWith(
    //     '<p class="tel"><img src="https://static.digiwin.com.tw/static/images/tel.png">免費諮詢熱線：0809-088-958</p>'
    // );
    // $(window)
    //     .bind("scroll resize", function () {
    //         const { scrollTop } = document.documentElement;
    //         const sectTop = $(".c2").offset().top;

    //         if (scrollTop > sectTop) {
    //             $(".header-box ").css({ display: "none" });
    //         } else {
    //             $(".header-box ").css({ display: "block" });
    //         }
    //     })
    //     .scroll();
});
